'use strict';


angular.module('app', [
    'angular-loading-bar',
    'ngAnimate',
    'ngCookies',
    'ngResource',
    'ngSanitize',
    'ngTouch',
    'ngStorage',
    'ui.router',
    'ui.bootstrap',
    'ui.load',
    'ui.jq',
    'ui.validate',
    'oc.lazyLoad',
    'pascalprecht.translate',
    'isteven-multi-select',
    'ngDialog',
    'ngRateIt'    
])

  .config(['cfpLoadingBarProvider', function(cfpLoadingBarProvider) {
    cfpLoadingBarProvider.includeSpinner = false;
    
//    taOptions.toolbar = [
//                ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'],
//                ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
//                ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
//                ['html', 'wordcount', 'charcount']
//            ];
  }])
  
  
//      .config(['$provide', function($provide){
//        // this demonstrates how to register a new tool and add it to the default toolbar
//        $provide.decorator('taOptions', ['$delegate', function(taOptions){
//            // $delegate is the taOptions we are decorating
//            // here we override the default toolbars and classes specified in taOptions.
//            forceTextAngularSanitize: true, // set false to allow the textAngular-sanitize provider to be replaced
//            //keyMappings : [],   // allow customizable keyMappings for specialized key boards or languages
//            taOptions.toolbar = [
//                ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'quote'],
//                ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
//                ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
//                ['html', 'wordcount', 'charcount']
//            ];
//            taOptions.classes = {
//                focussed: 'focussed',
//                toolbar: 'btn-toolbar',
//                toolbarGroup: 'btn-group',
//                toolbarButton: 'btn btn-default',
//                toolbarButtonActive: 'active',
//                disabled: 'disabled',
//                textEditor: 'form-control',
//                htmlEditor: 'form-control'
//            };        
//            
//            return taOptions; // whatever you return will be the taOptions
//        }]);
    
//        $provide.decorator('taOptions', ['taRegisterTool', '$delegate', function(taRegisterTool, taOptions){
//            // $delegate is the taOptions we are decorating
//            // register the tool with textAngular
//            taRegisterTool('colourRed', {
//                iconclass: "fa fa-square red",
//                action: function(){
//                    this.$editor().wrapSelection('forecolor', 'red');
//                }
//            });
//            // add the button to the default toolbar definition
//            taOptions.toolbar[1].push('colourRed');
//            return taOptions;
//        }]);
       
//    }])
  
  //Preloader
  .controller('AppController', ['$scope', '$rootScope', function($scope, $rootScope) {
    //console.log('INIT!!!!!!');      
    //Load
    $scope.$on('cfpLoadingBar:loading', function(event, data) {   
        $scope.dataLoaded = false;
        //console.log('INIT!!!!!!');
    });
    //Done
    $scope.$on('cfpLoadingBar:completed', function(event, data) {
        //$scope.flag = "off";
        $scope.dataLoaded = true;
        //console.log('DONE!!!!!!');
    });
                  
  }]);
  
